export default {
  "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["hallo i18n !! deutsch"])},
  "welcome": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Willkommen"])}
}